/*
Publicly available environment variables (almost all of them) are in environment.json.
Private environment variables (keys for internal tests, etc.) are in .env.

environment.json is built for non-local environments from values in the .cloudos directory.
environment.json for local environments is in the root directory.

IMPORTANT: /build/settings is an route alias; it cannot be referenced locally. 
Cloudfront routes this path to the S3 bucket, so resources there must be accessed via fetch().
*/

export const isLocal =
  process.env.NODE_ENV === 'local' ||
  process.env.NODE_ENV === 'test' ||
  process.env.NODE_ENV === 'development';

const localConfig = require('../environment.json');

let env = {
  REGION: '',
  LAUNCH_DARKLY: {
    API_KEY: '',
  },
  LOCAL_FEATURE_FLAGS: {
    DEBUGGABLE: true,
    ENV_LABEL: true,
  },
  MAPBOX: {
    TOKEN: '',
  },
  ORIGINS: {
    ADMIN: '',
    APPS: '',
    ADMINV2: '',
    ADMIN_API_V2: '',
    APIGEE_BACKEND: '',
    AUTHENTICATION: '',
    OXYGEN: '',
    BUILD: '',
    PROFILE: '',
  },
  APIGEE: {
    HQ: {
      VERSION: '',
    },
  },
  ANALYTICS: {
    MODULE_NAME: '',
    ENV: '',
    MIXPANEL: {
      TOKEN: '',
    },
  },
  PUBNUB: {
    CHANNEL_NAMES: {
      ACCOUNT_COMPANIES: '',
      ACCOUNT_USERS: '',
      PROJECT_COMPANIES: '',
      PROJECT_USERS: '',
    },
  },
  APIGEE_SERVICES: {
    ACC: '',
    HQ: '',
    HQV2: '',
    ADMIN_V2: '',
    HQV2INT: '',
  },
  AUTHENTICATION_URL: '',
  AUTHENTICATION_LOGOUT_URL: '',
  RESOURCE_HINTS_ORIGINS: ['', '', '', '', '', '', '', ''],
  EVERGAGE_URL: '',
  ENV_NAME: '',
};

let wasEnvFetched = false;

export async function fetchEnv() {
  if (!wasEnvFetched && !isLocal) {
    try {
      env = await (await fetch('/assets/admin/environment.json')).json();
      wasEnvFetched = true;
    } catch (e) {
      // TODO error should display a non-react error page.
    }
  }

  return env;
}

export function getEnv() {
  if (isLocal) {
    try {
      env = localConfig;
    } catch (e) {
      // Some error
    }
  }

  return env;
}
